export default "__VITE_ASSET__00c2b299__"